import React from 'react'
import styles from './styles.css'
import MdCreate from 'react-icons/lib/md/create'

export default class Title extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.container}>
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <h3 className={styles.title}>Agregar información a campos con nombres</h3>
            </div>
            <div className="col-xs-12 col-sm-6 end-md">
              <div className={styles.icon}>
                <MdCreate size={20} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/FillNameFields/Title/index.js